/* TGB Astronomicum funnel - gallery, sticky bar, 3D volvelle, atelier video.
   Idempotent (guarded on window.TGB.astroFunnel) and delegated at document
   level where possible, so theme-editor re-renders keep working. */
(function () {
  'use strict';
  window.TGB = window.TGB || {};
  if (window.TGB.astroFunnel) return;
  window.TGB.astroFunnel = true;

  /* ---------- 1. Hero gallery (delegated) ---------- */
  function selectGalleryImage(root, thumb) {
    var main = root.querySelector('.ax-gal__main img');
    var full = thumb.getAttribute('data-full');
    if (!main || !full) return;
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = full;
    main.alt = thumb.getAttribute('data-alt') || '';
    Array.prototype.forEach.call(root.querySelectorAll('[data-ax-thumb]'), function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
    if (thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  }
  document.addEventListener('click', function (ev) {
    var nav = ev.target.closest('[data-ax-gallery-nav]');
    if (nav) {
      var groot = nav.closest('[data-ax-gallery]');
      if (groot) {
        var thumbs = groot.querySelectorAll('[data-ax-thumb]');
        if (thumbs.length) {
          var current = 0;
          Array.prototype.forEach.call(thumbs, function (t, i) { if (t.classList.contains('is-active')) current = i; });
          var dir = nav.getAttribute('data-ax-gallery-nav') === 'prev' ? -1 : 1;
          selectGalleryImage(groot, thumbs[(current + dir + thumbs.length) % thumbs.length]);
        }
      }
      return;
    }
    var thumb = ev.target.closest('[data-ax-thumb]');
    if (!thumb) return;
    var root = thumb.closest('[data-ax-gallery]');
    if (root) selectGalleryImage(root, thumb);
  });

  /* ---------- 2. Sticky buy bar ---------- */
  function initSticky() {
    var bars = document.querySelectorAll('[data-ax-sticky]');
    Array.prototype.forEach.call(bars, function (bar) {
      if (bar.hasAttribute('data-ax-ready')) return;
      bar.setAttribute('data-ax-ready', '');
      if (bar.hasAttribute('data-follow-primary')) {
        var root = bar.closest('.ax-funnel');
        var primary = root && root.querySelector('.ax-hero .tgbc-buybox__cta');
        if (!primary) return;
        var footer = document.querySelector('.ax-sticky-stop') || document.querySelector('footer.tgb-footer, .shopify-section-group-footer-group footer') || document.querySelector('footer');
        var pending = false;
        function updatePrimaryVisibility() {
          pending = false;
          var rect = primary.getBoundingClientRect();
          var header = document.querySelector('sticky-header');
          var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
          var primaryVisible = rect.width > 0 && rect.top >= headerBottom && rect.bottom <= window.innerHeight;
          var pageFooter = document.querySelector('footer.tgb-footer, .shopify-section-group-footer-group footer') || footer;
        var footerRect = pageFooter && pageFooter.getBoundingClientRect();
          var atFooter = footerRect && footerRect.top < window.innerHeight && footerRect.bottom > 0;
          var show = !primaryVisible && !atFooter;
          bar.classList.toggle('is-on', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          bar.inert = !show;
        }
        function schedulePrimaryVisibility() {
          if (pending) return;
          pending = true;
          window.requestAnimationFrame(updatePrimaryVisibility);
        }
        if ('IntersectionObserver' in window) {
          var visibilityObserver = new IntersectionObserver(schedulePrimaryVisibility, { threshold: [0, 1] });
          visibilityObserver.observe(primary);
          if (footer) visibilityObserver.observe(footer);
        }
        window.addEventListener('scroll', schedulePrimaryVisibility, { passive: true });
        window.addEventListener('resize', schedulePrimaryVisibility, { passive: true });
        updatePrimaryVisibility();
        return;
      }
      var off = parseInt(bar.getAttribute('data-offset'), 10);
      if (isNaN(off)) off = 480;
      var foot = document.querySelector('.ax-sticky-stop') || document.querySelector('footer');
      var atFoot = false;
      function apply() { bar.classList.toggle('is-on', window.pageYOffset > off && !atFoot); }
      if ('IntersectionObserver' in window && foot) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { atFoot = e.isIntersecting; });
          apply();
        }, { threshold: 0.15 }).observe(foot);
      }
      window.addEventListener('scroll', apply, { passive: true });
      window.addEventListener('resize', apply, { passive: true });
      apply();
    });
  }

  /* ---------- 3. 3D volvelle ---------- */
  var SIGNS = ['Aries', 'Taurus', 'Gemini', 'Cancer', 'Leo', 'Virgo', 'Libra', 'Scorpio', 'Sagittarius', 'Capricorn', 'Aquarius', 'Pisces'];
  var GLYPH = ['♈︎', '♉︎', '♊︎', '♋︎', '♌︎', '♍︎', '♎︎', '♏︎', '♐︎', '♑︎', '♒︎', '♓︎'];
  var PLANET = ['☉︎', '☽︎', '☿︎', '♀︎', '♂︎', '♃︎', '♄︎'];

  function svgWrap(inner) {
    return '<svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg" role="presentation">' + inner + '</svg>';
  }
  function ring(r, fill, stroke, sw) {
    return '<circle cx="200" cy="200" r="' + r + '" fill="' + fill + '" stroke="' + stroke + '" stroke-width="' + (sw || 1) + '"/>';
  }
  function buildOuter() {
    var s = '<defs>'
      + '<radialGradient id="axPaper" cx="38%" cy="32%"><stop offset="0%" stop-color="#F8F2E2"/><stop offset="70%" stop-color="#EADFC4"/><stop offset="100%" stop-color="#D6C7A3"/></radialGradient>'
      + '<linearGradient id="axGold" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#E8CE83"/><stop offset="50%" stop-color="#C9A227"/><stop offset="100%" stop-color="#8C6D18"/></linearGradient>'
      + '</defs>';
    s += ring(196, 'url(#axPaper)', 'url(#axGold)', 3);
    s += ring(178, 'none', 'rgba(140,109,24,.55)', 1);
    s += ring(146, 'none', 'rgba(140,109,24,.35)', 1);
    var d, a, x1, y1, x2, y2, isLong, len;
    for (d = 0; d < 360; d += 2) {
      isLong = (d % 10 === 0); len = isLong ? 13 : 6;
      a = (d - 90) * Math.PI / 180;
      x1 = 200 + Math.cos(a) * 178; y1 = 200 + Math.sin(a) * 178;
      x2 = 200 + Math.cos(a) * (178 - len); y2 = 200 + Math.sin(a) * (178 - len);
      s += '<line x1="' + x1.toFixed(1) + '" y1="' + y1.toFixed(1) + '" x2="' + x2.toFixed(1) + '" y2="' + y2.toFixed(1) + '" stroke="rgba(60,45,10,' + (isLong ? .7 : .35) + ')" stroke-width="' + (isLong ? 1.2 : .7) + '"/>';
    }
    for (var i = 0; i < 12; i++) {
      var ang = i * 30, ar = (ang - 90) * Math.PI / 180;
      s += '<line x1="' + (200 + Math.cos(ar) * 146).toFixed(1) + '" y1="' + (200 + Math.sin(ar) * 146).toFixed(1) + '" x2="' + (200 + Math.cos(ar) * 178).toFixed(1) + '" y2="' + (200 + Math.sin(ar) * 178).toFixed(1) + '" stroke="rgba(140,109,24,.8)" stroke-width="1.1"/>';
      var mid = ang + 15, mr = (mid - 90) * Math.PI / 180;
      var gx = 200 + Math.cos(mr) * 168, gy = 200 + Math.sin(mr) * 168;
      var tx = 200 + Math.cos(mr) * 156, ty = 200 + Math.sin(mr) * 156;
      s += '<text x="' + gx.toFixed(1) + '" y="' + gy.toFixed(1) + '" font-size="14" fill="#7A5E14" text-anchor="middle" dominant-baseline="central" transform="rotate(' + mid + ' ' + gx.toFixed(1) + ' ' + gy.toFixed(1) + ')">' + GLYPH[i] + '</text>';
      s += '<text x="' + tx.toFixed(1) + '" y="' + ty.toFixed(1) + '" font-size="7.5" letter-spacing="1" font-family="Inter,sans-serif" fill="#6B5211" text-anchor="middle" dominant-baseline="central" transform="rotate(' + mid + ' ' + tx.toFixed(1) + ' ' + ty.toFixed(1) + ')">' + SIGNS[i].toUpperCase() + '</text>';
    }
    return s;
  }
  function buildMiddle() {
    var s = '<defs><radialGradient id="axBlue" cx="40%" cy="35%"><stop offset="0%" stop-color="#2E3C5E"/><stop offset="100%" stop-color="#16203C"/></radialGradient></defs>';
    s += ring(138, 'url(#axBlue)', 'url(#axGold)', 2);
    s += ring(120, 'none', 'rgba(201,162,39,.4)', 1);
    s += ring(92, 'none', 'rgba(201,162,39,.28)', 1);
    for (var d = 0; d < 360; d += 6) {
      var a = (d - 90) * Math.PI / 180, isLong = (d % 30 === 0);
      s += '<line x1="' + (200 + Math.cos(a) * 128).toFixed(1) + '" y1="' + (200 + Math.sin(a) * 128).toFixed(1) + '" x2="' + (200 + Math.cos(a) * (isLong ? 116 : 122)).toFixed(1) + '" y2="' + (200 + Math.sin(a) * (isLong ? 116 : 122)).toFixed(1) + '" stroke="rgba(232,206,131,' + (isLong ? .75 : .35) + ')" stroke-width="' + (isLong ? 1.1 : .6) + '"/>';
    }
    for (var i = 0; i < 7; i++) {
      var ang = i * (360 / 7), ar = (ang - 90) * Math.PI / 180;
      var px = 200 + Math.cos(ar) * 104, py = 200 + Math.sin(ar) * 104;
      s += '<circle cx="' + px.toFixed(1) + '" cy="' + py.toFixed(1) + '" r="12" fill="rgba(240,216,154,.16)" stroke="rgba(240,216,154,.75)" stroke-width="1"/>';
      s += '<text x="' + px.toFixed(1) + '" y="' + py.toFixed(1) + '" font-size="14" fill="#F3DEA8" text-anchor="middle" dominant-baseline="central">' + PLANET[i] + '</text>';
    }
    s += '<ellipse cx="200" cy="200" rx="70" ry="34" fill="none" stroke="rgba(232,206,131,.25)" stroke-width=".8"/>';
    s += '<ellipse cx="200" cy="200" rx="34" ry="70" fill="none" stroke="rgba(232,206,131,.25)" stroke-width=".8"/>';
    return s;
  }
  function buildTop() {
    var s = '';
    s += '<circle cx="200" cy="200" r="84" fill="#FBF6EA" stroke="url(#axGold)" stroke-width="2"/>';
    s += '<circle cx="200" cy="200" r="66" fill="none" stroke="rgba(140,109,24,.4)" stroke-width="1"/>';
    s += '<path d="M200 200 L192 60 L200 34 L208 60 Z" fill="url(#axGold)" stroke="#6B5211" stroke-width="1"/>';
    s += '<circle cx="200" cy="200" r="14" fill="#16203C" stroke="url(#axGold)" stroke-width="2"/>';
    s += '<circle cx="200" cy="200" r="4" fill="#E8CE83"/>';
    s += '<text x="200" y="248" font-size="26" fill="#8C6D18" text-anchor="middle">☉︎</text>';
    s += '<text x="200" y="266" font-size="6.5" letter-spacing="2" font-family="Inter,sans-serif" fill="#6B5211" text-anchor="middle">APIANVS 1540</text>';
    return s;
  }

  function initVolvelle(root) {
    if (root.hasAttribute('data-ax-ready')) return;
    root.setAttribute('data-ax-ready', '');
    var stage = root.querySelector('[data-ax-stage]');
    if (!stage) return;
    var stack = stage.querySelector('.ax-stack');
    var d3 = stage.querySelector('[data-disc="3"]');
    var d2 = stage.querySelector('[data-disc="2"]');
    var d1 = stage.querySelector('[data-disc="1"]');
    if (!stack || !d3 || !d2 || !d1) return;
    /* the middle/top discs reference the gradients defined in the outer disc's
       <defs> - SVG ids resolve document-wide, exactly as in the validated HTML */
    d3.innerHTML = svgWrap(buildOuter());
    d2.innerHTML = svgWrap(buildMiddle());
    d1.innerHTML = svgWrap(buildTop());

    var rot = { 1: 0, 2: 0, 3: 0 };
    var outSign = root.querySelector('[data-ax-out="sign"]');
    var outDeg = root.querySelector('[data-ax-out="deg"]');
    var outLayers = root.querySelector('[data-ax-out="layers"]');
    function apply() {
      stack.style.setProperty('--r1', rot[1] + 'deg');
      stack.style.setProperty('--r2', rot[2] + 'deg');
      stack.style.setProperty('--r3', rot[3] + 'deg');
      var rel = ((rot[1] - rot[3]) % 360 + 360) % 360;
      if (outSign) outSign.textContent = SIGNS[Math.floor(rel / 30)];
      if (outDeg) outDeg.textContent = Math.round(rel % 30) + '°';
    }

    var drag = null;
    function angleOf(e) {
      var r = stage.getBoundingClientRect();
      return Math.atan2(e.clientY - (r.top + r.height / 2), e.clientX - (r.left + r.width / 2)) * 180 / Math.PI;
    }
    stage.addEventListener('pointerdown', function (e) {
      var el = e.target.closest('[data-disc]');
      if (!el) return;
      drag = { id: el.getAttribute('data-disc'), start: angleOf(e), base: rot[el.getAttribute('data-disc')] };
      stage.classList.add('is-dragging');
      stage.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag) { /* parallax tilt */
        var r = stage.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - .5, py = (e.clientY - r.top) / r.height - .5;
        if (!stage.classList.contains('is-exploded')) {
          stack.style.setProperty('--rx', (16 - py * 14).toFixed(1) + 'deg');
          stack.style.setProperty('--ry', (px * 16).toFixed(1) + 'deg');
        }
        return;
      }
      rot[drag.id] = drag.base + (angleOf(e) - drag.start);
      apply();
    });
    function endDrag(e) {
      if (drag) { drag = null; stage.classList.remove('is-dragging'); }
      if (e && e.pointerId !== undefined) { try { stage.releasePointerCapture(e.pointerId); } catch (err) { } }
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);
    stage.addEventListener('pointerleave', function () {
      if (!stage.classList.contains('is-exploded')) {
        stack.style.setProperty('--rx', '16deg');
        stack.style.setProperty('--ry', '0deg');
      }
    });

    var expBtn = root.querySelector('[data-ax-explode]');
    var resetBtn = root.querySelector('[data-ax-reset]');
    if (expBtn) {
      expBtn.addEventListener('click', function () {
        var on = stage.classList.toggle('is-exploded');
        expBtn.textContent = on ? (expBtn.getAttribute('data-label-close') || expBtn.textContent) : (expBtn.getAttribute('data-label-open') || expBtn.textContent);
        if (outLayers) outLayers.textContent = on ? (outLayers.getAttribute('data-apart') || '3') : (outLayers.getAttribute('data-flat') || '3');
        if (on) { stack.style.setProperty('--ry', '-18deg'); }
        else { stack.style.setProperty('--rx', '16deg'); stack.style.setProperty('--ry', '0deg'); }
      });
    }
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        rot = { 1: 0, 2: 0, 3: 0 };
        apply();
        stage.classList.remove('is-exploded');
        if (expBtn) expBtn.textContent = expBtn.getAttribute('data-label-open') || expBtn.textContent;
        if (outLayers) outLayers.textContent = outLayers.getAttribute('data-flat') || '3';
        stack.style.setProperty('--rx', '16deg');
        stack.style.setProperty('--ry', '0deg');
      });
    }

    /* slow idle rotation of the middle ring until first interaction */
    var idle = true, t0 = null;
    stage.addEventListener('pointerdown', function () { idle = false; }, { once: true });
    function tick(ts) {
      if (!t0) t0 = ts;
      if (idle) { rot[2] = (ts - t0) / 120; apply(); }
      requestAnimationFrame(tick);
    }
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) { requestAnimationFrame(tick); }
    apply();
  }

  /* ---------- 4. Atelier video ---------- */
  function initVideo(wrap) {
    if (wrap.hasAttribute('data-ax-ready')) return;
    wrap.setAttribute('data-ax-ready', '');
    var vid = wrap.querySelector('video');
    var btn = wrap.querySelector('.ax-video__play');
    if (!vid || !btn) return;
    btn.addEventListener('click', function () {
      wrap.classList.add('is-playing');
      vid.setAttribute('controls', '');
      var p = vid.play();
      if (p && p.catch) p.catch(function () { });
    });
    vid.addEventListener('pause', function () { if (vid.currentTime === 0) wrap.classList.remove('is-playing'); });
    vid.addEventListener('ended', function () { wrap.classList.remove('is-playing'); vid.removeAttribute('controls'); });
  }

  function initAll() {
    initSticky();
    Array.prototype.forEach.call(document.querySelectorAll('[data-ax-volvelle]'), initVolvelle);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ax-video]'), initVideo);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
